module.exports = __webpack_public_path__ + "img/PL08310.0be7d1c5.png";